var Application = {
  session: null,
  helpMode: false,
  initialize: function () {
    // BOOTBOX : Langue FR
    bootbox.setDefaults({
      locale: 'fr'
    })

    this.homeView = new(require('views/home_view'))({ name: 'home' })
    this.loginView = new(require('views/login_view'))({ name: 'login' })
    this.accueilView = new(require('views/accueil_view'))({ name: 'accueil' })
    this.eventsView = new(require('views/events_view'))({ name: 'events' })
    this.divisionView = new(require('views/division_view'))({ name: 'division' })
    this.sportView = new(require('views/sport_view'))({ name: 'sport' })
    this.paysView = new(require('views/pays_view'))({ name: 'pays' })
    this.userView = new(require('views/user_view'))({ name: 'user' })
    this.user_profileView = new(require('views/user_profile_view'))({ name: 'user_profile' })
    this.conseilView = new(require('views/conseil_view'))({ name: 'conseil' })
    this.cartView = new(require('views/cart_view'))({ name: 'cart' })

    this.router = new(require('lib/router'))()
  },
  setSession: function (s) {
    this.session = s
  },
  // Ajax qui s'annule si on change de fil d'ariane
  ajax (opts) {
    opts = opts || {}
    opts.type = opts.type || 'GET'
    opts.timeout = opts.timeout != null || 25000
    opts.async = opts.async != null ? opts.async : true
    opts.global = opts.global != null ? opts.global : true

    // if (opts.type && opts.type !== 'GET') {
    //   opts.processData = opts.processData || false // Useful sinon error de token illegal du au formdata blahblahblah
    //   opts.contentType = opts.contentType || false // Useful pour que le navigateur puisse mettre le bon content type automatiquement
    // }
    opts.dataType = opts.dataType || 'json'
    this.xhr_encours = $.ajax(opts)
  },
  validator: function (el, rules, cb) {
    new FormValidator(el, rules, (errors, evt) => {
      evt.preventDefault()
      let SELECTOR_ERRORS = $('#error-box')
      let SELECTOR_SUCCESS = $('#success-box')
      if (errors.length > 0) {
        SELECTOR_ERRORS.empty()

        for (var i = 0, errorLength = errors.length; i < errorLength; i++) {
          SELECTOR_ERRORS.append(errors[i].message + '<br />')
        }

        SELECTOR_SUCCESS.hide()
        SELECTOR_ERRORS.fadeIn(200)
        var x = SELECTOR_ERRORS.offset().top - 200
        jQuery('html,body').animate({scrollTop: x}, 400)
      } else {
        SELECTOR_ERRORS.css({ display: 'none' });
        // SELECTOR_SUCCESS.fadeIn(200);
        if (typeof cb === 'function') {
          cb()
        } else {
          this.submitForm()
        }
      }
    })
  },
  onComplete: function (options, truthyValue) {
    var that = this
    options = options || {}
    return function (response, status, xhr) {
      var r = response
      if (r && r.responseText) {
        try {
          r = $.parseJSON(r.responseText)
        } catch (e) {
          r = false
        }
      }
      if (response.status === 200 && r && (typeof truthyValue === 'undefined' || (typeof truthyValue === 'function' && truthyValue(r, response)) || r === truthyValue)) {
        $('#error-box').hide()
        if (options.success) options.success(r)
        if (options.success_notice) that.notice(options.success_notice, 'success')
      } else {
        if (!r) {
          r = 'Impossible de traiter la demande, si le problème persiste, veuillez contacter l\'administrateur du site.'
        }
        if (options.error) options.error(r)
        else that.error(r)
      }
      if (options.complete) options.complete(r, status)
      else that.modalWaitClose()
    }
  },
  notice (body, title = '', type = 'success', timeout = 2000) {
  },
  error: function (r, noprefix) {
    if ($('#error-box').length) {
      $('#error-box').html(r).fadeIn()
    } else {
      $.notify({
        icon: 'glyphicon glyphicon-warning-sign',
        message: r,
        title: 'Erreur de traitement'
      }, {
        type: 'danger',
        placement: {
          from: 'top',
          align: 'center'
        }
      })
    }
  },
  loadScripts: {},
  loadScript: function (url, cb) {
    if (!this.loadScripts[url]) {
      this.loadScripts[url] = true
      var body = document.getElementsByTagName('body')[0]
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
      script.onload = cb
      body.appendChild(script)
    } else if (cb) {
      cb()
    }
  },
  select2: function (el, conf) {
    $(el).select2({
      ajax: conf.ajax || null,
      minimumInputLength: conf.minimumInputLength || 0,
      allowClear: conf.allowClear || true,
      width: conf.width || '100%',
      selectOnBlur: conf.selectOnBlur || true,
      placeholder: conf.placeholder || '-- Choisissez un enregistrement --',
      data: conf.data || null,
      initSelection: conf.initSelection || null,
      multiple: conf.multiple || null,
      templateResult: conf.templateResult,
      closeOnSelect: conf.closeOnSelect || true,
      tags: conf.tags || false,
      createSearchChoice: conf.createSearchChoice || null
    })
  },
  loadError: function (el) {
  },
  noResults: function (el) {
    if (el) {
      $(el).addClass('noResults')
      const text = $('#search-ui').val() ? 'Aucun résultat pour la recherche <em>’' + $('#search-ui').val() + '’</em>.' : 'Aucun résultat'

      $(el).html('<h3><i class="fa fa-warning"></i> ' + text + ' </h3>')
    }
  },
  parseDate: function (f) {
    if (!f) f = 'LLLL'
    $('.date').each(function (k, o) {
      if ($(o).text()) {
        var d = Date.parse($(o).text())
        if (isNaN(d)) return
        var tmp = moment(d).format(f)
        if (tmp !== 'Invalid date') $(o).text(tmp)
      }
    })

    $('.fromNow').each(function (k, o) {
      if ($(o).text()) {
        var d = Date.parse($(o).text())
        if (isNaN(d)) return
        var tmp = moment(d).fromNow()
        if (tmp !== 'Invalid date') $(o).text(tmp)
      }
    })
  },
  parseTime: function (v) {
    $('.time').each(function (k, o) {
      var h = $(o).text()
      if (h) {
        var m = Math.round(60 * ((h * 100) % 100) / 100)
        if (isNaN(m)) return h
        if (m === 0) {
          m = '00'
        } else if (m < 10) {
          m = '0' + m
        }
        h = Math.floor(h)

        var r
        if (h >= 7) { // Calcul des jours
          var j = Math.floor(h / 7)
          h = h % 7
          r = j + 'j ' + h + 'h' + m
        }

        $(o).text(r || h + 'h' + m)
      }
    })
  },
  initList: function (f) {
    // On traite les tri
    this.initSort()
      // Parse des date a formatter
    this.parseDate(f)

    this.initTooltip()
      // Activation des popover présent dans l'HTML
    $('[rel="popover"]').popover()
  },
  initTooltip: function () {
    this.closeAllTooltips()
      // Activation des tooltip présent dans l'HTML
    $('[rel="tooltip"]').tooltip({
      trigger: 'hover'
    })
  },
  closeAllTooltips: function () {
    $('[rel="tooltip"]').tooltip('hide')
  },
  pagination: function (mod, xhr) {
    if (!xhr || !mod) return
    if ($('#pagination-' + mod).length) {
      $('#pagination-' + mod).empty().html(require('views/templates/pagination')({
        pages: xhr.getResponseHeader('ps-max-page'),
        noLimit: xhr.getResponseHeader('ps-no-limit'),
        page: xhr.getResponseHeader('ps-active-page')
      })).show()
    }
    if ($('#' + mod + '-count').length) $('#' + mod + '-count').html(xhr.getResponseHeader('ps-total-row') + ' élement(s)').show()
  },
  initSort: function () {
    var tri = $('#tri-ui').val()
    if (!tri) return
    if (tri) {
      $("th.sortable div[data-tri='" + tri + "']").parent().addClass($('#trid-ui').val())
    }
  },

  initDateTimepickers: function (el, opts) {
    opts = opts || {}
    el = el || '.datepicker'
    $('.datepicker').datetimepicker({
      locale: 'fr',
      format: 'DD-MM-YYYY',
      minDate: opts.minDate || false,
      maxDate: opts.maxDate || false
    })
  },
  modalWait (action) {
    if (action === 'hide' || action === 'close') this.modalWaitClose()
    else {
      this.bootbox = bootbox.dialog({
        message: `<div class="text-center">
                    <div class="load-wrapp">
                      <div class="load">
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                      </div>
                      <h4>Chargement en cours...</h4>
                    </div>
                  </div>`,
        onEscape: false,
        backdrop: true,
        closeButton: false,
        size: 'small'
      })
    }
  },
  modalWaitClose () {
    if (this && this.bootbox && this.bootbox.modal) this.bootbox.modal('hide')
  },
  initCart (e) {
    if (localStorage && !localStorage.getItem('cart')) {
      let cart = {}
      cart.products = []

      localStorage.setItem('cart', JSON.stringify(cart))
    }
  },
  getCart () {
    if (localStorage && localStorage.getItem('cart')) {
      let cart = JSON.parse(localStorage.getItem('cart'))
      return cart
    }
  },
  checkDroits (session, view, event) {
    let profil = session && session.user ? session.user.profil : null


    if (!view) return true
    if (view === 'accueil') return true
    if (view === 'login') return true
    if (view === 'user_profile') return true
    switch (profil) {
      case 'admin':
        return true
      case 'expert':
        if (view === 'user') return false
        if (view === 'cart') return true
        if (view === 'conseil') return true
        break
      case 'visiteur':
        if (view === 'user') return false
        if (view === 'cart') return true
        break
      default:
        if (view === 'accueil') return true
        if (view === 'cart') return true
        return false
    }
  }
}

module.exports = Application
